import { PAGINATION } from "@config/constant"
import { useAppDispatch } from "@hook/useAppDispatch"
import { changePageTitleAction } from "@reducer/common.reducer"
import { callGetComboCategories } from "@reducer/version2/categories.reducer"
import { callGetListCombo } from "@reducer/version2/skuCombo.reducer"
import { trans } from "@resources/localization"
import React, { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { Filter } from "./Filter"
import { List } from "./ListSkuCombo"

export const SKUCombo: React.FC = () => {
    const [searchParams] = useSearchParams()
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(callGetComboCategories())
        const params = Object.fromEntries(searchParams.entries())
        if (params.tab === "skuCombo") {
            dispatch(changePageTitleAction(trans("skuCombo.title")))
            delete params.createdAt
            delete params.tab

            dispatch(
                callGetListCombo({
                    ...params,
                    pageSize: searchParams.has("pageSize") ? Number(searchParams.get("pageSize")) : PAGINATION.DEFAULT_PAGE_SIZE,
                    page: searchParams.has("page") ? Number(searchParams.get("page")) : PAGINATION.DEFAULT_CURRENT_PAGE,
                })
            )
        }
    }, [dispatch, searchParams])

    return (
        <div>
            <Filter />
            <List />
        </div>
    )
}
